export function addCalledServiceSettingsFileUploadValidation(calledservicesettingsfileuploadvalidation) {
  return {
      type: 'ADD_CALLED_SERVICE_SETINGS_FILE_UPLOAD_VALIDATION',
      calledservicesettingsfileuploadvalidation,
  }
}